module.exports = __webpack_public_path__ + "img/banner2.b377e901.jpg";